import { render } from "./CreateEventModal.vue?vue&type=template&id=1c0d68e5"
import script from "./CreateEventModal.vue?vue&type=script&lang=js"
export * from "./CreateEventModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__